'use client'

import Image from 'next/image'
import { useQuery } from '@tanstack/react-query'
import { apiGetAllNews } from '@/services/newsHome/api'

const ForeignPartnersSection = () => {
    const NEWS_TYPE_ID = Number(process.env.NEXT_PUBLIC_HOME_LOGO);

    const { data } = useQuery({
        queryKey: ['foreign-partners-logos', NEWS_TYPE_ID],
        queryFn: async () => {
            const res = await apiGetAllNews({
                keywords: '',
                newsTypeId: NEWS_TYPE_ID,
                isPublic: 'true',
                page: 1,
                pageSize: 100
            })
            return res?.isOK ? res.result.items : []
        },
        staleTime: 5 * 60 * 1000,
        enabled: !!NEWS_TYPE_ID,
    })

    const partnerItem = data?.find((item: any) => item.title === 'Logo nước ngoài')

    const descriptionParts = (partnerItem?.description || "").split('\n')
    const title = descriptionParts[0] || "Đối tác toàn cầu"
    const subTitle = descriptionParts[1] || ""
    const rawLogos = (() => {
        if (!partnerItem) return []
        const contentHtml = partnerItem.content || ""
        const regex = /<img[^>]+src="([^">]+)"/g
        const extractedImages: string[] = []
        let match
        while ((match = regex.exec(contentHtml)) !== null) {
            if (match[1]) extractedImages.push(match[1])
        }
        return extractedImages
    })()

    // 5. Nhân đôi mảng logo
    const LOGOS = rawLogos.length > 0 ? [...rawLogos, ...rawLogos] : []

    // 6. Tính toán tốc độ chạy
    const logoCount = rawLogos.length || 1;
    const durationMobile = `${logoCount * 3}s`;
    const durationDesktop = `${logoCount * 8}s`;
    const durationSuperWide = `${logoCount * 12}s`;

    if (LOGOS.length === 0) return null

    return (
        <section className="py-8 xl:py-12 2xl:py-16 min-[1920px]:py-24 bg-white dark:bg-white overflow-hidden transition-colors duration-300">
            <div className="max-w-7xl 2xl:max-w-[90rem] min-[1920px]:max-w-[110rem] mx-auto px-6 xl:px-8 2xl:px-12 min-[1920px]:px-20 text-center">

                <h2
                    className="text-xl xl:text-3xl 2xl:text-4xl min-[1920px]:text-6xl mb-3 xl:mb-4 2xl:mb-6 min-[1920px]:mb-10"
                    style={{
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                        color: "#2D3746",
                        fontWeight: 600
                    }}
                >
                    {title}
                </h2>

                <p
                    className="text-xs xl:text-[15px] 2xl:text-lg min-[1920px]:text-2xl max-w-full xl:max-w-3xl 2xl:max-w-4xl min-[1920px]:max-w-6xl mx-auto mb-6 xl:mb-10 2xl:mb-14 min-[1920px]:mb-20 leading-relaxed"
                    style={{
                        fontFamily: "'Helvetica Neue', Arial, sans-serif",
                        color: "#2D3746",
                    }}
                >
                    {subTitle}
                </p>

                <div className="relative">
                    <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-12 xl:w-48 2xl:w-60 min-[1920px]:w-80 bg-gradient-to-r from-white dark:from-white to-transparent z-10" />
                    <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-12 xl:w-48 2xl:w-60 min-[1920px]:w-80 bg-gradient-to-l from-white dark:from-white to-transparent z-10" />

                    <div className="overflow-hidden h-10 xl:h-14 2xl:h-20 min-[1920px]:h-28 flex items-center">
                        <div
                            className="flex animate-marquee-fast whitespace-nowrap"
                            style={{
                                '--dur-mobile': durationMobile,
                                '--dur-desktop': durationDesktop,
                                '--dur-super': durationSuperWide
                            } as React.CSSProperties}
                        >
                            {LOGOS.map((src, index) => (
                                <div
                                    key={`${index}-${src}`}
                                    className="mx-4 xl:mx-10 2xl:mx-14 min-[1920px]:mx-24 flex-shrink-0 w-[90px] xl:w-[120px] 2xl:w-[160px] min-[1920px]:w-[240px] flex items-center justify-center"
                                >
                                    <Image
                                        src={src}
                                        alt={`Đối tác quốc tế ${index}`}
                                        width={240}
                                        height={120}
                                        className="h-7 xl:h-10 2xl:h-14 min-[1920px]:h-20 w-auto max-w-full object-contain transition-all duration-300"
                                        unoptimized={true}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                @keyframes marquee-fast {
                    from { transform: translateX(0); }
                    to { transform: translateX(-50%); }
                }
                .animate-marquee-fast {
                    animation: marquee-fast var(--dur-mobile) linear infinite;
                    will-change: transform;
                }
                @media (min-width: 1280px) {
                    .animate-marquee-fast { animation-duration: var(--dur-desktop); }
                }
                @media (min-width: 1920px) {
                    .animate-marquee-fast { animation-duration: var(--dur-super); }
                }
            `}</style>
        </section>
    )
}

export default ForeignPartnersSection